import axios from 'axios';
import { url } from '../../../../../../env';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  Accept: 'application/json',
});

const multipartHeaders = () => ({
  ...authHeaders(),
  'Content-Type': 'multipart/form-data',
});

export const insuranceApi = {
  show: (qpId) =>
    axios.get(`${url}/quote-process/${qpId}/insurance`, { headers: authHeaders() }),

  template: (qpId, params = {}) =>
    axios.get(`${url}/quote-process/${qpId}/insurance/template`, {
      headers: authHeaders(),
      params,
    }),

  sendEmail: (qpId, formData) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/email`, formData, {
      headers: multipartHeaders(),
    }),

  // Pide una URL prefirmada por archivo para subir directo a S3. El PDF no pasa
  // por Lambda, que corta en ~4.4 MB con un 413 (ver Utils/s3Upload.js).
  getUploadUrls: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/upload-urls`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  // Registra en el backend los archivos ya subidos a S3, por su key.
  uploadKeys: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/upload`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  // Ruta multipart original. El backend la sigue aceptando; queda para archivos
  // chicos y como salida rápida si hubiera que revertir.
  uploadPDFs: (qpId, formData) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/upload`, formData, {
      headers: multipartHeaders(),
    }),

  getExtraction: (documentId) =>
    axios.get(`${url}/asset-documents/${documentId}/extraction`, { headers: authHeaders() }),

  consolidated: (qpId) =>
    axios.get(`${url}/quote-process/${qpId}/insurance/consolidated`, { headers: authHeaders() }),

  complete: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/complete`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  reject: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/insurance/reject`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  modify: (insuranceId, formData) =>
    axios.post(`${url}/insurance/${insuranceId}/modify`, formData, {
      headers: multipartHeaders(),
    }),

  cancel: (insuranceId, formData) =>
    axios.post(`${url}/insurance/${insuranceId}/cancel`, formData, {
      headers: multipartHeaders(),
    }),

  reopen: (insuranceId, payload) =>
    axios.post(`${url}/insurance/${insuranceId}/reopen`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  correct: (insuranceId, formData) =>
    axios.post(`${url}/insurance/${insuranceId}/correct`, formData, {
      headers: multipartHeaders(),
    }),

  timeline: (insuranceId) =>
    axios.get(`${url}/insurance/${insuranceId}/timeline`, { headers: authHeaders() }),

  providers: (type = 'insurance') =>
    axios.get(`${url}/providers`, { headers: authHeaders(), params: { type } }),

  getInsurancePayments: (insuranceId) =>
    axios.get(`${url}/insurance/${insuranceId}/payments`, { headers: authHeaders() }),

  getDocumentUrl: (documentId) =>
    axios.get(`${url}/asset-documents/${documentId}/url`, { headers: authHeaders() }),
};

export default insuranceApi;
